
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    startAmount : '0',
    endAmount : '3832207',
    income: '100000',
    numYears : '22',
    currentAge : '40',
    retireAge : '62',
    returnPct : '8',
    inflationPct: '3',
    socialSecurity: '0',
    timeframe: 'Annually',
    payment: '0',
    paymentRate: 'Annually',
    taxPct: '24',
    enableTax: true,
    resetCount: 0,
  },

  actions: {
    reset ({commit}) {
      commit('RESET')
    },
    update_end({commit}, value) {
      commit('UPDATE_END', value)
    },
  },
  mutations: {
    RESET (state) {
      state.startAmount = '0'
      state.endAmount = '0'
      state.income = '100000'
      state.numYears = '22'
      state.currentAge = '40'
      state.retireAge = '62'
      state.returnPct = '8'
      state.inflationPct = '3'
      state.socialSecurity = '0'
      state.timeframe = 'Annually'
      state.payment = '0'
      state.paymentRate = 'Annually'
      state.taxPct = '24'
      state.enableTax = true
      state.resetCount += 1
    },
    UPDATE_ALL_INCOME (state, value) {
      state.savings = value.savings
      state.retireAge = value.retireAge
      state.currentAge = value.currentAge
      state.returnPct = value.returnPct
      state.inflationPct = value.inflationPct
      state.timeframe = value.timeframe
      state.income = value.income
      state.socialSecurity = value.socialSecurity
      //growth values
      state.numYears = (value.retireAge - value.currentAge).toString()
      state.startAmount = value.savings
      state.resetCount += 1
    },
    UPDATE_ALL_GROWTH (state, value) {
      state.startAmount = value.startAmount
      state.endAmount = value.endAmount
      state.numYears = value.numYears
      state.returnPct = value.returnPct
      state.taxPct = value.taxPct
      state.enableTax = value.enableTax
      state.paymentRate = value.paymentRate
      state.resetCount += 1
    },
    UPDATE_END (state, value) {
      state.endAmount = value
    },
  },
})

export default store
